import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { FileUploadModule, FileSelectEvent } from 'primeng/fileupload';

enum MidiaTipo {
  IMAGEM = 'Imagem',
  VIDEO = 'Video',
  DOCUMENTO = 'Documento'
}

@Component({
  selector: 'app-campanha-midia-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    Select,
    InputTextModule,
    ButtonModule,
    DividerModule,
    RadioButtonModule,
    FileUploadModule
  ],
  templateUrl: './campanha-midia-dialog.component.html'
})
export class CampanhaMidiaDialogComponent implements OnInit {

  form!: FormGroup;

  fileSelecionado?: File;

  tipos = [
    { label: 'Imagem', value: MidiaTipo.IMAGEM },
    { label: 'Vídeo', value: MidiaTipo.VIDEO },
    { label: 'Apresentação / Documento', value: MidiaTipo.DOCUMENTO }
  ];

  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      campanhaId: [this.config.data.campanhaId, Validators.required],
      tipo: [null, Validators.required],
      descricao: ['', Validators.required],
      url: [''],
      origem: ['arquivo', Validators.required]
    });
  }

  get origem() {
    return this.form.get('origem')?.value;
  }

  onFileSelect(event: FileSelectEvent): void {

    const file = event.files[0];

    if (!file) {
      return;
    }

    if (!this.validarArquivo(file)) {
      this.fileSelecionado = undefined;
      return;
    }

    this.fileSelecionado = file;
  }

  validarArquivo(file: File): boolean {

  const allowedTypes = [
    'application/pdf',

    'image/png',
    'image/jpeg',
    'image/gif',

    'video/mp4',
    'video/x-matroska'
  ];

  if (!allowedTypes.includes(file.type)) {

    this.messageService.add({
      severity: 'error',
      summary: 'Arquivo inválido',
      detail: 'Formato não permitido.'
    });

    return false;
  }

  return true;
}

  salvar(): void {

    if (this.form.invalid) {

      this.form.markAllAsTouched();

      this.messageService.add({
        severity: 'warn',
        summary: 'Validação',
        detail: 'Preencha todos os campos obrigatórios.'
      });

      return;
    }

    const usandoUrl = this.origem === 'url';

    if (usandoUrl && !this.form.value.url) {

      this.messageService.add({
        severity: 'warn',
        summary: 'URL obrigatória',
        detail: 'Informe uma URL.'
      });

      return;
    }

    if (!usandoUrl && !this.fileSelecionado) {

      this.messageService.add({
        severity: 'warn',
        summary: 'Arquivo obrigatório',
        detail: 'Selecione um arquivo.'
      });

      return;
    }

    const formData = new FormData();

    formData.append(
      'CampanhaID',
      this.form.value.campanhaId
    );

    formData.append(
      'Tipo',
      this.form.value.tipo
    );

    formData.append(
      'Descricao',
      this.form.value.descricao
    );

    if (usandoUrl) {

      formData.append(
        'Url',
        this.form.value.url
      );
    } else {

      formData.append(
        'File',
        this.fileSelecionado!
      );
    }

    this.ref.close(formData);
  }

  cancelar(): void {
    this.ref.close();
  }

  onFileClear(): void {
  this.fileSelecionado = undefined;
}
}